/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './Limitations.scss'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { ILimitation, IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ILimitationsProps {
	data: IInpatientTypeInsurance
}
interface ILimitationsState {
	collapse: number
}

export class LimitationsComponent extends React.Component<ILimitationsProps, ILimitationsState> {
	constructor(props: Readonly<ILimitationsProps>) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = { collapse: 0 }
	}
	toggle(e):void {
		const event = e.target.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}

	render(): React.ReactNode {
		const limitationsModel = this.props.data

		let first = true
		const limitationsFound = limitationsModel.limitations !== undefined && limitationsModel.limitations.length > 0

		if (limitationsFound) {
			return !limitationsModel.limitations
				? ''
				: limitationsModel.limitations.map((element, index) => {
						const getLines = (input: ILimitation): string => {
							first = false
							let line = ''

							if (input.quantityQualifier === '99') {
								line = `<span><strong>` + input.used + `</strong> Sessions Used</span>`
							}
							if (input.remaining > 0) {
								line = `<strong>` + input.remaining + `</strong> Sessions Remaining`
							}
							if (input.total > 0) {
								line += (line.length > 0 ? ' of ' : '') + `<strong>` + input.total + `</strong> Base Sessions`
							}
							if (CommonUtils.isValidDate(input.eligibleDate)) {
								line += `&nbsp;&nbsp;| Next Eligible:` + CommonUtils.getDate(input.eligibleDate, 'MM/DD/YYYY')
							}
							if (CommonUtils.isValidDate(input.effectiveDate)) {
								line += `&nbsp;&nbsp;| Effective Date:` + CommonUtils.getDate(input.effectiveDate, 'MM/DD/YYYY')
							}
							if (!CommonUtils.isUndefinedOrNull(input.message) && input.message !== '') {
								line += ` - ` + input.message
							}

							return line
						}
						return (
							<tr key={index}>
								<td>{first ? 'Limitations:' : ''}</td>
								<td colSpan={3}>{parse(getLines(element))}</td>
							</tr>
						)
				  })
		} else {
			return <></>
		}
	}
}
